import { ErrorWrapper, ResponseWrapper } from '../util'
import { BaseService } from './../base'

export class DirectoryService extends BaseService {
  static get entity () {
    return 'directory'
  }
  static get name () {
    return 'directory'
  }

  static async getDirectoriesFindByCellar (cellarId) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_by_cellar_id/${cellarId}`)
      return new ResponseWrapper(response, response.data.document)
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getChildren (cellarId) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_child_by_directory_id/${cellarId}`)
      return new ResponseWrapper(response, response.data[this.entity])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getCountByDependencyId (id) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/count_by_dependency_id/${id}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
}